/*** IMPORTS FROM imports-loader ***/
var define = false;

"use strict";

var stringUtil = require("../util/string");

var queryParser = require("./searchQuery-jison");

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Private
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

// matches quotes globally
var addQuotes = new RegExp('"', "g");

// matches a string that needs quotes
var needsQuotesRegex = new RegExp("[\\s:()]|^and$|^or$|^not$", "i");

// matches quotes at the start/end and escaped quotes (\")
var removeQuotesRegex = new RegExp('^(?:\\s*)"|(?:\\\\")|"(?:\\s*)$', "g");

//-------------------------------------------
function unquoteReplace(value) {
    return (value === '"' ? "" : '"');
}


//-------------------------------------------
function unquote(value) {
    return (typeof value === "string"
        ? value.replace(removeQuotesRegex, unquoteReplace)
        : value);
}


//-------------------------------------------
function quote(value) {
    return (typeof value === "string" && needsQuotesRegex.test(value)
        ? '"'.concat(value.replace(addQuotes, '\\"'), '"')
        : value);
}



//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// SearchQuery view-model
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
// Represents a structured search query.
function SearchQuery(children, phrase, property, type) {
    if (stringUtil.isNullOrWhitespace(type)) { throw new Error("type must be a string."); }

    switch (type) {
    case "and":
    case "or":
        if (!Array.isArray(children) || children.length < 2) { throw new Error("'and' and 'or' types must contain at least two items"); }
        this.children = children;
        this.type = type;
        break;
    case "not":
        if (!Array.isArray(children) || children.length !== 1) { throw new Error("'not' type must contain exactly one item"); }
        this.children = children;
        this.type = type;
        break;
    case "property":
        if (stringUtil.isNullOrWhitespace(property)) { throw new Error("'property' type must specify property"); }
        this.phrase = phrase;
        this.property = property;
        this.type = type;
        break;
    default:
        if (stringUtil.isNullOrWhitespace(phrase)) { throw new Error("'default' type must specify phrase"); }
        this.property = "";
        this.phrase = phrase;
        this.type = "default";
        break;
    }
}


//-------------------------------------------
SearchQuery.prototype.buildBinary = function searchQueryBuildBinary(type, children) {
    var result;
    switch (type) {
    case "and":
    case "not":
    case "or":
        result = new SearchQuery(
            Array.isArray(children) ? children : [].splice.call(arguments, 1, arguments.length),
            null,
            null,
            type
        );
        break;
    default:
        throw new Error("only 'and', 'not' and 'or' types are supported.");
    }
    return result;
};


//-------------------------------------------
SearchQuery.prototype.buildPhrase = function searchQueryBuildPhrase(phrase) {
    return new SearchQuery(null, phrase, null, "default");
};


//-------------------------------------------
SearchQuery.prototype.buildProperty = function searchQueryBuildProperty(property, phrase) {
    return new SearchQuery(null, phrase, property, "property");
};


//-------------------------------------------
SearchQuery.prototype.load = function searchQueryLoad(value) {
    var result = null;
    if (!stringUtil.isNullOrWhitespace(value)) {
        result = SearchQuery.prototype.buildPhrase(value);
    } else if (Array.isArray(value)) {
        if (value.length === 2) {
            result = SearchQuery.prototype.buildProperty(value[0], value[1]);
        }
    } else if (typeof value === "object") {
        var children, type, i, l;
        if (Array.isArray(value.and)) {
            type = "and";
            children = value.and;
        } else if (Array.isArray(value.or)) {
            type = "or";
            children = value.or;
        } else if (value.not) {
            type = "not";
            children = [value.not];
        }
        if (type) {
            for (i = 0, l = children.length; i < l; i += 1) {
                children[i] = SearchQuery.prototype.load(children[i]);
            }
            result = SearchQuery.prototype.buildBinary(type, children);
        }
    }
    return result;
};


//-------------------------------------------
SearchQuery.prototype.parse = function searchQueryParse(s) {
    return SearchQuery.prototype._loadParsed(queryParser.parse(s));
};


//-------------------------------------------
SearchQuery.prototype.toString = function searchQueryToString() {
    return SearchQuery.prototype._buildQuery(this);
};


//-------------------------------------------
// Builds the string representation of a SearchQuery.
SearchQuery.prototype._buildQuery = function searchQueryBuildQuery(query) {
    switch (query.type) {
    case "and":
        return SearchQuery.prototype._buildQueryGroup(query.children, " AND ");
    case "not":
        var child = query.children[0],
            parsed = SearchQuery.prototype._buildQuery(child);
        return "NOT "
            .concat(child.type === "and" || child.type === "or"
                ? "(".concat(parsed, ")")
                : parsed);
    case "or":
        return SearchQuery.prototype._buildQueryGroup(query.children, " OR ");
    case "property":
        return "".concat(quote(query.property), ":", quote(query.phrase));
    default:
        return quote(query.phrase);
    }
};


//-------------------------------------------
SearchQuery.prototype._buildQueryGroup = function searchQueryBuildQueryGroup(children, separator) {
    if (!Array.isArray(children)) { return ""; }

    var result = [], i, l,
        child, parsed;
    for (i = 0, l = children.length; i < l; i += 1) {
        child = children[i];
        parsed = SearchQuery.prototype._buildQuery(child);
        result.push((child.type === "and" || child.type === "or" || child.type === "not")
            ? "(".concat(parsed, ")")
            : parsed);
    }
    return result.join(separator);
};


//-------------------------------------------
// Loads the jison parsed result.
SearchQuery.prototype._loadParsed = function searchQueryLoadParsed(s) {
    var binaryOperator, left, right,
        result = false;
    if (!stringUtil.isNullOrWhitespace(s)) {
        s = unquote(s);
        result = stringUtil.isNullOrWhitespace(s) ? null : SearchQuery.prototype.buildPhrase(s);
    } else if (Array.isArray(s)) {
        switch (s.length) {
        case 2:
            result = SearchQuery.prototype.buildProperty(unquote(s[0]), unquote(s[1]));
            break;
        case 3:
            binaryOperator = s[1] === "implied" ? "and" : s[1];
            left = SearchQuery.prototype._loadParsed(s[0]);
            right = SearchQuery.prototype._loadParsed(s[2]);
            if (left === null || right === null) {
                result = left || right;
            } else if (left.type === binaryOperator && right.type === binaryOperator) {
                result = SearchQuery.prototype.buildBinary(binaryOperator, left.children.concat(right.children));
            } else if (left.type === binaryOperator) {
                result = SearchQuery.prototype.buildBinary(binaryOperator, left.children.concat([right]));
            } else if (right.type === binaryOperator) {
                result = SearchQuery.prototype.buildBinary(binaryOperator, [left].concat(right.children));
            } else {
                result = SearchQuery.prototype.buildBinary(binaryOperator, [left, right]);
            }
            break;
        }
    } else if (typeof s === "object") {
        if (s.brackets !== undefined) {
            result = SearchQuery.prototype._loadParsed(s.brackets);
        } else if (s.not !== undefined) {
            result = SearchQuery.prototype.buildBinary("not", SearchQuery.prototype._loadParsed(s.not));
        }
    }
    return result;
};

module.exports = {
    buildBinary: SearchQuery.prototype.buildBinary,
    buildPhrase: SearchQuery.prototype.buildPhrase,
    buildProperty: SearchQuery.prototype.buildProperty,
    load: SearchQuery.prototype.load,
    parse: SearchQuery.prototype.parse
};




//////////////////
// WEBPACK FOOTER
// ./~/pli/searchquery/searchQuery.js
// module id = 371
// module chunks = 49